/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tense_Loved_Anaconda_SurgeInputs */

const fr_tense_loved_anaconda_surge = /** @type {(inputs: Tense_Loved_Anaconda_SurgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requiert un moyen de paiement`)
};

/**

* @param {Tense_Loved_Anaconda_SurgeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const tense_loved_anaconda_surge = /** @type {((inputs?: Tense_Loved_Anaconda_SurgeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tense_Loved_Anaconda_SurgeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_tense_loved_anaconda_surge(inputs)
});